import { registerLang, setCurrentLocale } from 'react-easy-i18n';

import enAU from './lang/en-au'; // au english
import enUK from './lang/en-uk'; // uk english
import enUS from './lang/en-us'; // us english

// localization initialization using react-easy-i18n
// https://www.npmjs.com/package/react-easy-i18n

export default class localise {
  static data;
  static code;
  static rtl = false; // right left : true for hebrew and arabic

  static getString(id) {
    // get raw text from language data

    let arr = id.split('.');
    let x = localise.data;

    for (let i = 0; i < arr.length; i++) {
      if (x) x = x[arr[i]];
    }

    // if not found return id

    if (!x) {
      console.log('localise.getString ' + id + ' not found');
      x = id;
    }

    return x;

    // process call cause problems in the testing
    //return process(id)
  }

  static getfirst(id) {
    // getfirst used in dropdown fields to obtain first value in array
    // Ternary used to also support key:value pairs in arrays
    return typeof id[0].value === 'undefined' ? id[0] : id[0].value;

    // process call cause problems in the testing
    //return process(id)
  }

  static countryCodeToLangCode(country) {
    // map cochlear country code to 2 character language id

    let res = { data: enAU, code: 'en-au' }; // default

    // main cochlear website supported countries
    // we only handle these codes

    // au: australia new zealand
    // at: austria
    // cz: czech republic
    // dk: denmark
    // fi: finland
    // fr: france
    // de: germany
    // hu: hungary
    // il: israel
    // it: italy
    // nl: netherlands
    // ro: romainia
    // es: spain
    // sv: sweden
    // ch: switzerland
    // tr: turkey
    // uk: united kingdom

    // sg: singapore
    // in: india
    // cn: china
    // jp: japan
    // hk: hong kong/taiwan
    // id: indonesia
    // my: malaysia
    // pk: pakistan
    // ph: phillipines
    // lk: sri lanka
    // th: thailand
    // vn: vietnam

    // la: latin america
    // br: brazil
    // me: middle east
    // uk/africa: uk and africa
    // ru: russia
    // us: united states

    switch (country) {
      case 'au':
        res = { data: enAU, code: 'en-au' };
        break;
      case 'uk':
      case 'uk/en':
        res = { data: enUK, code: 'en-uk' };
        break;
      case 'us':
      case 'us/en':
        res = { data: enUS, code: 'en-us' };
        break;
    }

    return res;
  }

  static init(country) {
    localise.country = country;

    // call once at start of app
    let res = localise.countryCodeToLangCode(country);
    localise.data = res.data;
    localise.code = res.code;
    registerLang('en', localise.data);
    // registerLang('de', de);
    // registerLang('es', es);
    // registerLang('ml', ml);
    // registerLang('zh', zh);
    // registerLang('da', da);
    // registerLang('fi', fi);
    // registerLang('fr', fr);
    // registerLang('hu', hu);
    // registerLang('he', he);
    // registerLang('ar', ar);
    // registerLang('it', it);
    // registerLang('nl', nl);
    // registerLang('ro', ro);
    // registerLang('sv', sv);
    // registerLang('tk', tk);
    // registerLang('hi', hi);
    // registerLang('ja', ja);
    // registerLang('id', id);
    // registerLang('ur', ur);
    // registerLang('th', th);
    // registerLang('vi', vi);
    // registerLang('ru', ru);
    // registerLang('cs', cs);

    if (localise.data) setCurrentLocale(localise.data);
  }
}
